export default __webpack_public_path__ + "static/media/devGuy.782a6683.svg";